

























































































































































































helpers = require('../../helpers.coffee')
summernote = require('../../libraries/summernote_comments.coffee')

view_model = {
  data: ->
    contact: new Contact
    flow: null
    show_flow_autocomplete: false
    show_summernote: false
    selected_task: new Task
    current_user: Session.current_user
    show_lost_reason_modal: false
    temp_attr: null
    lost_reason: null
    prop_tooltip_placement: 'left'
    schedule_reactivation_contact: null

  components:
    flowAutocomplete: require('../shared/autocomplete/flows')
    contactEvents: require('./events')
    contactTasks: require('./tasks')
    contactForm: require('./form')
    userDropdown: require('./user_dropdown')
    tag: require('../tags/tag')
    tagPickerModal: require('../tags/picker_modal')
    lostReasonModal: require('../shared/modals/lost_reason_modal')
    reactivateRecipientModal: require('../automatic_tasks/reactivate_recipient_modal')

  computed:
    show_flow_dropdown: ->
      (!Session.current_user.isSeller() || Session.current_user.id == @contact.user_id) && @contact.recipient_status != 'blocklisted'

    show_new_task_button: ->
       Session.current_user.id == @contact.user_id

    user_can_edit_comment: ->
      Session.current_user.id == @contact.user_id || ( Session.current_user.isAdmin() || Session.current_user.isManager() )

    has_business: ->
      @contact.business?.id != null

  methods:
    updateLostContact: (lost_reason) ->
      attr = @temp_attr
      attr['lost_reason_id'] = lost_reason.id
      attr['lost_reason_comment'] = lost_reason.comment
      attr['send_to_new_flow'] = lost_reason.send_to_new_flow
      attr['due_on_date_custom'] = lost_reason.due_on_date_custom
      attr['flow'] = lost_reason.flow
      attr['immediately'] = lost_reason.immediately
      attr['stage'] = lost_reason.stage if lost_reason.stage
      attr['status'] = lost_reason.status if lost_reason.status
      attr['schedule_set_contact_stage'] = lost_reason.schedule_set_contact_stage if lost_reason.schedule_set_contact_stage
      @updateContact(attr)
      @show_lost_reason_modal = false

    setLostInfo: (attr) ->
      if attr.stage == 'lost'
        @temp_attr = attr
        @show_lost_reason_modal = true
      else
        @updateContact(attr)

    closeLostReasonModal: ->
      @show_lost_reason_modal = false

    toggleTaskBar: (data) ->
      EventsBus.$emit 'toggle-task-bar', {contact_id: data.contact.id, task: data.task}

    updateContactInfo: (flow) ->
      @updateStages()
      @contact.flow = flow
      @flow = flow
      @contact.recipient.flow_id = flow.id if @contact.recipient

    updateStages: ->
      @contact.recipient_status = 'uninitialized'
      @contact.human_recipient_status = 'Não iniciado'
      return unless @contact.stage == 'lost'
      @contact.stage = @contact.previous_stage
      @contact.human_stage = @contact.human_previous_stage

    showFlowAutocomplete: ->
      show_flow_autocomplete = true

    hideFlowAutocomplete: ->
      show_flow_autocomplete = false

    toogleSummernote: ->
      if @user_can_edit_comment
        @show_summernote = !@show_summernote
      else
        alertify.error 'Você não tem permissão para criar novos comentários neste contato'

    inializeSummernote: ->
      @$comment = jQuery('#comment')
      summernote(@$comment, focus: false)
      @$comment.summernote('code','')

    setContact: (contact) ->
      @contact = contact
      @flow = contact.flow

    saveComment:->
      comment_text = @$comment.summernote('code')
      if comment_text.length == 0 || comment_text == '&nbsp;'
        alertify.error 'Não é possível inserir um comentário sem conteúdo'
        return

      Loader.on()
      @comment_events_resource = new CommentEventsResource @contact.id
      params = {
        contact_id: @contact.id
        author: Session.current_user.name
        comment: comment_text
      }
      @comment_events_resource.create @saveCommentSuccess, @unknownError, params

    saveCommentSuccess: (data) ->
      Loader.off()
      alertify.success 'Comentário salvo com sucesso!'
      @$refs.contact_events.addEvent(data.event)
      @cancelComment()

    cancelComment: ->
      @show_summernote = !@show_summernote
      @$comment.summernote('code','')

    loadSuccess: (resources) ->
      @setContact resources.contact
      EventsBus.$emit 'contact-loaded', { @contact }
      Loader.off()

    loadContact: ->
      Loader.on()
      params = {include_contact_custom_fields: true}
      @contact_resource.get @loadSuccess, @loadFailure, id: @$route.params.id, params: params

    loadFailure:(data) ->
      if data.status == 403
        @$router.push '/contatos/leads'
      else
        alertify.error 'Erro desconhecido ao carregar contato'

    openScheduleReactivationModal: (event) ->
      @schedule_reactivation_contact = @contact
      jQuery('#recipient-schedule-reactivation').modal('show')

    scheduleReactivationText: ->
      if @contact.recipient and @contact.recipient.reactivate_automatic_task.constructor == Task
        'Editar Reativação'
      else
        'Agendar Reativação'

    updateContact: (data) ->
      data.id = @contact.id
      @contact_resource.update @updateContactSuccess, @unknownError, data
      if data.stage?
        IntercomCtrl.trackEvent("Base de contatos - estágio de contato modificada para #{data.stage}",{
          'Identificador do contato': @contact.id,
        })
      else
        IntercomCtrl.trackEvent("Base de contatos - responsável de contato modificado", {
          'Identificador do contato': @contact.id
          'Identificador do novo responsável': data.user_id
        })

    updateContactRecipient: (event, data) ->
      @updateContactstatus(data)

    updateContactstatus: (data) ->
      if @contact.recipient?.id
        params = { contact_id: @contact.id, id: @contact.recipient.id, status: data.status }
        @contact_resource.updateRecipient @updateContactSuccess, @unknownError, params
      else
        params = { id: @contact.id, status: data.status }
        @contact_resource.update @updateContactSuccess, @unknownError, params

    connectedAndSendToNewFlow: (event) ->
      return if @show_lost_reason_modal == true
      event.stopPropagation()
      attr = { status: 'connected', event: 'send_to_new_flow' }
      attr.contact_id = @contact.id
      attr.id = @contact.recipient.id
      @temp_attr = attr
      @updateContactstatus({ status: 'connected' })
      @show_lost_reason_modal = true

    connectedAndLost: (event) ->
      event.stopPropagation()
      attr = { status: 'connected', event: 'lost' }
      attr.contact_id = @contact.id
      attr.id = @contact.recipient.id
      @temp_attr = attr
      # @updateContactstatus({ status: 'connected' })
      @temp_attr = { stage: 'lost', status: 'lost', new_status: 'connected' }
      @show_lost_reason_modal = true

    connectedAndCreateTask: (event) ->
      event.stopPropagation()
      attr = { status: 'connected' }
      attr.contact_id = @contact.id
      attr.id = @contact.recipient.id
      @temp_attr = attr
      @updateContactstatus({ status: 'connected' })
      EventsBus.$emit 'TaskModalForm::Show', { task_id: null, contact: @contact, id: 'manual-task-form-modal', show_stage_selection: true }

    connectedAndChangeStage: (event) ->
      event.stopPropagation()
      attr = { status: 'connected', event: 'change_stage' }
      attr.contact_id = @contact.id
      attr.id = @contact.recipient.id
      @temp_attr = attr
      @updateContactstatus({ status: 'connected' })
      @show_lost_reason_modal = true

    openRemoveContactFromFlowModal: ->
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-remove-contact-from-flow'

    confirmRemoveContactFromFlow: ->
      @contact_resource.removeFromFlow(
        @updateContactSuccess, @unknownError,
        id: @contact.id, flow_id: @contact.flow.id
      )

    updateContactSuccess: (resources) ->
      @setContact resources.contact
      @$refs.contact_tasks.reloadTasks()
      alertify.success 'Contato atualizado com sucesso!'

    viewFlow: ->
      @$router.push path: @flowPath()

    flowPath: ->
      "/fluxos-de-cadencia/#{@flow.id}"

    newTask: (event) ->
      EventsBus.$emit 'TaskModalForm::Show', { contact: @contact, id: 'dialer-manual-task-form-modal' }

    removeContact: ->
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-remove-contact'

    confirmRemoveContact: ->
      @contact_resource.destroy(@removeContactSuccess, @unknownError, id: @contact.id)

    removeContactSuccess: ->
      @$router.push path: '/contatos/leads'
      alertify.success('Contato excluído com sucesso')

    removeTag: (data) ->
      params = { id: @contact.id, contact_tags_attributes: [{ id: data.taggable_tag_id, _destroy: true }] }
      @contact_resource.update @removeTagSuccess(data), @unknownError, params

    removeTagSuccess: (data) ->
      (response) =>
        alertify.success 'Tag removida com sucesso!'
        @contact.tags = @contact.tags.filter (tag) ->
          tag.taggable_tag_id != data.taggable_tag_id

    openTagsModal: ->
      @$refs.tag_picker_modal.reloadTags()
      jQuery('#'+@tag_picker_id).modal('show')

    addTagsToContact: (tags) ->
      return unless tags.length
      contact_tags_attributes = for tag in tags
        { tag_id: tag.id }
      @contact_resource.update @addTagsSuccess, @unknownError, {id: @contact.id, contact_tags_attributes}

    addTagsSuccess: (data) ->
      @setContact(data.contact)
      alertify.success('Tags adicionada ao contato com sucesso')

    loadTaskInfo: (data) ->
      Loader.on()
      @tasks_resources.get @loadTaskInfoSuccess, @unknownError, id: data.task.id

    loadTaskInfoSuccess: (data) ->
      @selected_task = data.task
      EventsBus.$emit 'confirm-modal-show', id: 'contact-create-template-modal'
      Loader.off()

    taskDestroyed: (data) ->
      @$refs.contact_events.addEvent(new ContactEvent(data.event))

    updateLoading: (loading) ->
      if loading then Loader.on() else Loader.off()

  created: ->
    @tag_picker_id = 'tag-picker-interno'
    @contact_resource = new ContactsResource Session.current_company.id
    @tasks_resources = new TasksResource
    EventsBus.$on 'contact-updated', @setContact
    EventsBus.$emit 'close-task-bar', parseInt(@$route.params.id)
    EventsBus.$on 'Show::UpdateContactsInfo', @updateContactInfo
    @loadContact()

  mounted: ->
    @inializeSummernote()

  beforeDestroy:  ->
    EventsBus.$off 'contact-updated', @setContact
    EventsBus.$off 'Show::UpdateContactsInfo', @updateContactInfo
}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.manual_tasks.list_wrapper, helpers.contacts.styles)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/show.vue